import React, {useEffect, useState} from "react";
import {getDetailForm, updateForm} from "../../repositories/FormRepository";
import {AddIcon} from "../../components/svg/AddIcon";
import {DeleteIcon} from "../../components/svg/DeleteIcon";
import bannerImg from "../../assets/image/banner.jpg";
import {useForm} from "react-hook-form";
import {notificationAlert} from "../../util/alert";
import {useNavigate, useParams} from "react-router-dom";
import {MathJax, MathJaxContext} from "better-react-mathjax";
import {Author} from "../../model/Author";
import {isIterableArray} from "../../util/common";
import router from "../../router";


const FormModifyPage: React.FC = () => {
    const [formCount, setFormCount] = useState<number>(1);
    const [refCount, setRefCount] = useState<number>(1);
    const {register, setValue, handleSubmit, watch, formState: {errors}} = useForm<any>();
    const {id} = useParams<{ id: string }>();
    const navigator = useNavigate();

    const onSubmit = async (data: any) => {
        try {
            data.references = data.references.filter((ref: any) => ref !== '');
            let formData = {...data};
            if (formData.coauthors) {
                formData.coauthors = formData.coauthors.filter((coa: Author) => {
                    if (coa.email || coa.name || coa.affiliation || coa.country) {
                        return coa;
                    }
                    return;
                });
            }

            const result = await updateForm(formData);
            if (result) {
                notificationAlert('notification', 'Success');
                navigator(-1);
            }
        } catch (err) {
            notificationAlert('notification', 'server error');
        }
    }

    useEffect(() => {
        if (id) {
            handleGetDetailForm(id);
        }
    }, [id])

    const handleGetDetailForm = async (formId: string) => {
        try {
            const result = await getDetailForm(formId);
            if (result) {
                setValue('id', result.id);
                setValue('section', result.section);
                setValue('session', result.session);
                setValue('title', result.title);
                setValue('author', result.author);
                setValue('coauthors', result.coauthors);
                setValue('abstractMath', result.abstractMath);
                setValue('references', result.references);
                setValue('msc', result.msc);
                setValue('keywords', result.keywords);
                setValue('createAt', result.createAt);

                if (isIterableArray(result.coauthors)) {
                    setFormCount(result.coauthors.length)
                }

                if (isIterableArray(result.references)) {
                    setRefCount(result.references.length)
                }
            }

        }  catch (err: any) {
            notificationAlert('notification', err?.message || 'server error');
            setTimeout(() => {
                navigator('/list');
            }, 1000)
        }
    }

    return (
        <div className={'form_page'}>
            <MathJaxContext config={{
                tex2jax: {
                    inlineMath: [['$', '$'], ['\\(', '\\)']],
                    displayMath: [['$', '$'], ['\\(', '\\)']],
                },
            }} version={2} hideUntilTypeset={'every'}>
                <div className={'container'}>
                    <div className={'banner'}>
                        <img src={bannerImg} alt={'banner_img'}/>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className={'form_box_row'}>
                            <div className={'title flex_row_center'}>
                                <h5>Section <span>*</span></h5>
                            </div>
                            <div className={'content'}>
                                <label>
                                    <input {...register('section', {required: true})} type={'radio'}
                                           value={'Plenary Lecture'}/>
                                    Plenary Lecture
                                </label>
                                <label>
                                    <input {...register('section', {required: true})} type={'radio'}
                                           value={'Contributed Talk'}/>
                                    Contributed Talk
                                </label>
                            </div>
                            {errors.section && <span className={'validation_msg'}>This field is required</span>}
                        </div>
                        <div className={'form_box_row'}>
                            <div className={'title flex_row_center'}>
                                <h5>Session <span>*</span></h5>
                            </div>
                            <div className={'content'}>
                                <label>
                                    <input {...register('session', {required: true})} type={'radio'} value={'Ring'}/>
                                    Ring
                                </label>
                                <label>
                                    <input {...register('session', {required: true})} type={'radio'} value={'Module'}/>
                                    Module
                                </label>
                                <label>
                                    <input {...register('session', {required: true})} type={'radio'}
                                           value={'Representation'}/>
                                    Representation
                                </label>
                            </div>
                            {errors.session && <span className={'validation_msg'}>This field is required</span>}
                        </div>
                        <div className={'form_box_row'}>
                            <div className={'title flex_row_center'}>
                                <h5>Title(Eng.) <span>*</span></h5>
                            </div>
                            <div className={'content'}>
                                <p>*Please type numerical formula in title using
                                    LaTeX. <span>Do NOT use all capital.</span>
                                </p>
                                <textarea {...register('title', {required: true})}/>
                                <div>
                                    <MathJax hideUntilTypeset={"every"} inline dynamic>
                                        {watch("title")}
                                    </MathJax>
                                </div>
                            </div>
                            {errors.title && <span className={'validation_msg'}>This field is required</span>}
                        </div>
                        <div className={'form_box_column'}>
                            <div className={'form_title'}>
                                <div className={'title flex_row_center'}>
                                    <h5>
                                        Name of presenting author
                                        <span>*</span>
                                    </h5>
                                </div>
                                <div className={'title flex_row_center'}>
                                    <h5>
                                        Affiliation
                                    </h5>
                                </div>
                                <div className={'title flex_row_center'}>
                                    <h5>
                                        E-mail
                                    </h5>
                                </div>
                                <div className={'title flex_row_center'}>
                                    <h5>
                                        Country
                                    </h5>
                                </div>
                            </div>
                            <div className={'form_content'}>
                                <div className={'form_item'}>

                                    <div className={'content'}>
                                        <input {...register('author.name', {required: true})} type={'text'}/>
                                        {errors.author &&
                                            <span className={'validation_msg'}>This field is required</span>}
                                    </div>
                                </div>
                                <div className={'form_item'}>

                                    <div className={'content'}>
                                        <input {...register('author.affiliation')} type={'text'}/>
                                    </div>
                                </div>
                                <div className={'form_item'}>
                                    <div className={'content'}>
                                        <input {...register('author.email')} type={'text'}/>
                                    </div>
                                </div>
                                <div className={'form_item'}>
                                    <div className={'content'}>
                                        <input {...register('author.country')} type={'text'}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'form_box_column'}>
                            <div className={'form_title'}>
                                <div className={'title flex_row_center'}>
                                    <h5>
                                        Coauthor(s)
                                    </h5>
                                </div>
                                <div className={'title flex_row_center'}>
                                    <h5>
                                        Affiliation
                                    </h5>
                                </div>
                                <div className={'title flex_row_center'}>
                                    <h5>
                                        E-mail
                                    </h5>
                                </div>
                                <div className={'title flex_row_center'}>
                                    <h5>
                                        Country
                                    </h5>
                                </div>
                            </div>
                            {Array.from(Array(formCount).keys()).map(num => <div className={'form_content'}>
                                <div className={'form_item'}>

                                    <div className={'content'}>
                                        <input {...register(`coauthors[${num}].name`)} type={'text'}/>
                                    </div>
                                </div>
                                <div className={'form_item'}>

                                    <div className={'content'}>
                                        <input {...register(`coauthors[${num}].affiliation`)} type={'text'}/>
                                    </div>
                                </div>
                                <div className={'form_item'}>
                                    <div className={'content'}>
                                        <input {...register(`coauthors[${num}].email`)} type={'text'}/>
                                    </div>
                                </div>
                                <div className={'form_item'}>
                                    <div className={'content'}>
                                        <input {...register(`coauthors[${num}].country`)} type={'text'}/>
                                    </div>
                                </div>
                            </div>)}

                        </div>
                        <div className={'add_form'}>
                            <button type={'button'} onClick={() => setFormCount(old => old + 1)}>
                                <AddIcon/>
                            </button>
                            <button type={'button'} onClick={() => {
                                if (formCount > 1) {
                                    setFormCount(old => old - 1);
                                    setValue(`coauthors[${formCount - 1}].name`, '');
                                    setValue(`coauthors[${formCount - 1}].affiliation`, '');
                                    setValue(`coauthors[${formCount - 1}].email`, '');
                                    setValue(`coauthors[${formCount - 1}].country`, '');
                                }
                            }}>
                                <DeleteIcon/>
                            </button>
                        </div>

                        <div className={'form_box_row'}>
                            <div className={'title flex_row_center'}>
                                <h5>Abstract <span>*</span></h5>
                            </div>
                            <div className={'content'}>
                                <textarea {...register('abstractMath', {required: true})} name={'abstractMath'}/>
                                <div>
                                    <MathJax hideUntilTypeset={"every"} inline  dynamic>
                                        {watch("abstractMath")}
                                    </MathJax>
                                </div>
                            </div>
                            {errors.abstractMath && <span className={'validation_msg'}>This field is required</span>}
                        </div>
                        <div className={'form_box_row'}>
                            <div className={'title flex_row_center'}>
                                <h5>References <span>*</span></h5>
                            </div>
                            <div className={'content'}>
                                <div className={'ref_form'}>
                                    {Array.from(Array(refCount).keys()).map(num =>
                                        <label>
                                            {`${num + 1}.`}
                                            <input {...register(`references[${num}]`)}
                                                   type={'text'}/>
                                        </label>
                                    )
                                    }
                                    <div className={'add_form'}>
                                        <button type={'button'} onClick={() => setRefCount(old => old + 1)}>
                                            <AddIcon/>
                                        </button>
                                        <button type={'button'} onClick={() => {
                                            if (refCount > 1) {
                                                setRefCount(old => old - 1);
                                                setValue(`references[${refCount - 1}]`, '');
                                                setValue(`references[${refCount - 1}]`, '');
                                                setValue(`references[${refCount - 1}]`, '');
                                                setValue(`references[${refCount - 1}]`, '');
                                            }
                                        }}>
                                            <DeleteIcon/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'form_box_row'}>
                            <div className={'title flex_row_center'}>
                                <h5>MSC number(s) <span>*</span>  <p style={{marginLeft: '1rem'}}>(ex. 53A25)</p></h5>
                            </div>
                            <div className={'content'}>
                                <input {...register('msc', {required: true})} className={'msc_input'} type={'text'}
                                       name={'msc'}/>
                            </div>
                            {errors.msc && <span className={'validation_msg'}>This field is required</span>}
                        </div>
                        <div className={'form_box_row'}>
                            <div className={'title flex_row_center'}>
                                <h5>Keyword(s) <span>*</span></h5>
                            </div>
                            <div className={'content'}>
                                <textarea {...register('keywords', {required: true})} />
                            </div>
                            {errors.keywords && <span className={'validation_msg'}>This field is required</span>}
                        </div>
                        <button
                            className={'active'}
                            disabled={Object.keys(errors).length !== 0}
                            id={'submit_btn'} type={'submit'}>Modify
                        </button>
                    </form>
                </div>
            </MathJaxContext>
        </div>
    )
}


export default FormModifyPage;
